<template>
<div class="table_wrapper">
    <table
      class="qb-table vs-table vs-table--tbody-table striped-table permit-table"
      :style="{ overflow: 'auto', height: 'auto' }"
      :id="tableId"
    >
      <thead>
        <slot name="thead"></slot>
      </thead>

      <tbody style="overflow: auto">
        <slot name="tbody"></slot>
      </tbody>
    </table>
    </div>
</template>
<script>
export default {
  props: {
    tableId: {
      type: String,
      default: 'qb-table-1',
    },
    height: {
      type: String,
      default: '5vh',
    },
  },
}
</script>

<style lang="scss">
.table_wrapper{
    display: block;
    overflow-x: auto;
    white-space: nowrap;
}

.qb-table {
  border-collapse: collapse;
  width: 100%;
}

.qb-table td,
.qb-table th {
  border: 0px solid #ddd;
  padding: 8px;
}

// .qb-table tr:nth-child(even) {
//   background-color: #f2f2f2;
// }

.qb-table tr:hover {
  background-color: #ddd;
}

// .qb-table th {
//   background-color: #BC1300;
//   color: white;
// }
</style>
